import { render } from "./ReleaseAccessSearch.vue?vue&type=template&id=aa34f3fa"
import script from "./ReleaseAccessSearch.vue?vue&type=script&lang=js"
export * from "./ReleaseAccessSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__